import {
    AQuote,
    RequestDataUpdate,
} from '../AQuotes.types'

const getRequestData = (
    aQuote: AQuote,
    initialData: AQuote,
): RequestDataUpdate => {
    return {
        requestedLanes: aQuote.requestedLanes.reduce((acc, {
            accountLane,
            productTypes,
            baseLeaseDays,
            otherComments,
        }) => {
            const isExist = initialData.requestedLanes.some(({
                accountLane: {
                    id: accountLaneId,
                },
            }) => {
                return accountLaneId === accountLane.id
            })

            if (!isExist) {
                return [
                    ...acc,
                    {
                        accountLane: {
                            id: accountLane.id,
                        },
                        baseLeaseDays,
                        otherComments,
                        productTypes,
                    },
                ]
            }

            return acc
        }, []),
    }
}

export default getRequestData
